import { motion } from "motion/react";
import { Instagram, Linkedin, MessageCircle } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_16e04e72-902a-4ec2-915f-9027a566527c/artifacts/zlzlzxe9_logo%20BHG%20preferido%20fondo%20transparente%20HR.webp";

const COLUMNS = [
  {
    title: "Navega",
    links: [
      { label: "Inicio", href: "#inicio" },
      { label: "Método", href: "#metodo" },
      { label: "Proyectos", href: "#proyectos" },
      { label: "Servicios", href: "#servicios" },
      { label: "Ecosistema", href: "#ecosistema" },
      { label: "Participa", href: "#participa" },
    ],
  },
  {
    title: "Ecosistema",
    links: [
      { label: "Hato Cristero", href: "#ecosistema" },
      { label: "CADTEBA", href: "#ecosistema" },
      { label: "La Vitrina", href: "#ecosistema" },
    ],
  },
  {
    title: "Contacto",
    links: [
      { label: "WhatsApp", href: "https://wa.me/584244528345" },
      { label: "Correo", href: "mailto:glendapalai@bhg-barinasheritageglobal.com" },
      { label: "Calendly", href: "https://calendly.com/glendapalai/30min" },
      { label: "LinkedIn", href: "https://www.linkedin.com/in/glenda-elisabete-xavier-de-sena-093068201" },
    ],
  },
];

export const Footer = () => {
  return (
    <div className="px-4 md:px-8 pb-8 max-w-7xl mx-auto">
      <motion.footer
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        className="liquid-glass w-full rounded-3xl p-6 md:p-10 text-white/70 mt-32 md:mt-64"
        data-testid="main-footer"
      >
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 mb-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="BHG" className="h-12 w-auto" data-testid="footer-logo" />
              <span className="text-[#C6A15B] font-serif-display text-xl font-semibold">
                BHG · Barinas Heritage Global
              </span>
            </div>
            <p className="text-sm max-w-sm" data-testid="footer-tagline">
              Arquitectura de destino · Somos puente, no muro.
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-3 gap-6">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm uppercase tracking-wider text-white font-medium mb-4">
                  {col.title}
                </h4>
                <ul className="text-xs space-y-2">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target={link.href.startsWith("http") ? "_blank" : undefined}
                        rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
                        className="hover:text-white transition-colors"
                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xs text-center md:text-left" data-testid="footer-copyright">
            © 2026 Barinas Heritage Global. El horizonte es el límite. · Autoría Cle&amp;Fábula ·{" "}
            <a
              href="https://bhg-privacidad.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors underline underline-offset-2"
              data-testid="footer-link-privacidad"
            >
              Privacidad y Términos
            </a>
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs">Síganos:</span>
            <a
              href="https://instagram.com/glenda_enelmundo"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-colors"
              aria-label="Instagram"
              data-testid="footer-social-instagram"
            >
              <Instagram size={16} />
            </a>
            <a
              href="https://www.linkedin.com/in/glenda-elisabete-xavier-de-sena-093068201"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-colors"
              aria-label="LinkedIn"
              data-testid="footer-social-linkedin"
            >
              <Linkedin size={16} />
            </a>
            <a
              href="https://wa.me/584244528345"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-colors"
              aria-label="WhatsApp"
              data-testid="footer-social-whatsapp"
            >
              <MessageCircle size={16} />
            </a>
          </div>
        </div>
      </motion.footer>
    </div>
  );
};
